'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  placeholder: 'Выберите время'
};
exports["default"] = locale;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/time-picker/locale/ru_RU.tsx
 ** module id = 730
 ** module chunks = 1
 **/